// Constants
import { MESSAGE_EVENT_TYPE } from './constants/iframe.handlers.constants';
// Types
import { IframeBuilderHandlersType, IframeMethodsHandlersType } from './types/iframe.handlers.type';

const catchFrameComponentLoadErrorEventHandler = ({
  setError,
}: Pick<IframeBuilderHandlersType, 'setError'>): void => {
  setError(true);
};

const checkFrameComponentLoadSuccessEventHandler = ({
  setFrameLoaded,
}: Pick<IframeBuilderHandlersType, 'setFrameLoaded'>): void => {
  setFrameLoaded(true);
};

const fetchFrameUrlFromAPIEventHandler = async ({
  resolver,
  setError,
  setFetching,
  setSrc,
}: Omit<IframeBuilderHandlersType, 'setFrameLoaded'>): Promise<void> => {
  setFetching(true);

  const [response] = await resolver();

  response?.url ? setSrc(response.url) : setError(true);
  setFetching(false);
};

const addIframeEventListenerHandler = ({
  onEventListen,
}: Pick<IframeBuilderHandlersType, 'onEventListen'>): void => {
  onEventListen && window.addEventListener(MESSAGE_EVENT_TYPE, onEventListen, false);
};

const removeIframeEventListenerHandler = ({
  onEventListen,
}: Pick<IframeBuilderHandlersType, 'onEventListen'>): void => {
  onEventListen && window.removeEventListener(MESSAGE_EVENT_TYPE, onEventListen, false);
};

const IframeHandlers = ({
  onEventListen,
  resolver,
  setFrameLoaded,
  setFetching,
  setError,
  setSrc,
}: IframeBuilderHandlersType): IframeMethodsHandlersType => ({
  handleAddIframeEventListener: () => addIframeEventListenerHandler({ onEventListen }),
  handleCleanIframeEventListener: () => removeIframeEventListenerHandler({ onEventListen }),
  handleCatchFrameComponentLoadErrorEvent: () =>
    catchFrameComponentLoadErrorEventHandler({ setError }),
  handleCheckFrameComponentLoadSuccessEvent: () =>
    checkFrameComponentLoadSuccessEventHandler({ setFrameLoaded }),
  handleFetchFrameUrlFromAPIEvent: () =>
    fetchFrameUrlFromAPIEventHandler({ resolver, setFetching, setError, setSrc }),
});

export { IframeHandlers };
